// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--26b78";
export var intro = "hero-module--intro--97c41";